import { resourceHeaders } from './resource-actions.factory';

/**
 * @typedef {object} IPendingSheetResource
 * @property {() => ng.resource.IResource<import('types/api').V1.PendingSheetFromAPI[]>} query
 * @property {(sheet: { id: string }) => ng.resource.IResource<import('types/api').V1.PendingSheetFromAPI>} delete
 * @property {(sheet: { id: string }) => ng.resource.IResource<import('types/api').V1.PendingSheetFromAPI>} retry
 */

export default [
  '$resource',
  PendingSheetResource
];

/**
 * @param {ng.resource.IResourceService} $resource
 * @return {IPendingSheetResource}
 */
export function PendingSheetResource($resource) {
  // @ts-ignore
  return $resource(
    '/api/v1/sheets/pending/:id',
    { id: '@id' },
    {
      'query': {
        method: 'GET',
        isArray: true,
        headers: resourceHeaders.get,
        timeout: 20000
      },
      'delete': {
        method: 'DELETE',
        headers: resourceHeaders.get,
        timeout: 20000
      },
      'retry': {
        url: '/api/v1/sheets/pending/:id/retry',
        method: 'POST',
        headers: resourceHeaders.get,
        timeout: 20000
      }
    }
  );
}